/**
 * Contains app related configuration.
 * In sync with AppConfigObject of the java part.
 */
export class AppConfigDto {
    euLoginRegisterUrl: string;
    euloginAccountEditUrl: string;
    euloginLogoutUrl: string;
    portalBaseUrl: string;
    regDocUrl: string;
    maintenanceRedirectionUrl: string;
    euAnalyticsSitePath: string;
}
